import { Component, OnInit, AfterViewInit, Input, ElementRef, ViewChild, Injector } from "@angular/core";
import { NgbActiveModal, NgbModalRef, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AppComponentBase } from "../../../services/AppComponentBase";
import { FormGroup, FormControl, FormBuilder, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import * as jQuery from "jquery";
import { DataService } from "../../../services/data/data.service";
import { Workspace } from "../../../model/workspace.data";
import { IDemoUser } from "../../../interfaces/IDemoUsers";
import { CreateAccountRequest } from "../../../model/create-account.request.data";
import { AgGridModule } from "ag-grid-angular";
import { GridOptions, GridApi, ColumnApi, ColDef } from "ag-grid";
import { AgGridNg2 } from "ag-grid-angular";
import { strategyCellRendererComponent } from "../../../renderers/strategyCellRendererComponent.component";
import { GlobalGridModeService } from "../../../services/globalGridMode/globalGridMode.service";
import { callNextAsync } from "../../../services/BaseService";
import { currencyRenderer } from "../../../renderers/currencyFormatters.component";

@Component({
    selector: "modal-liveUsers",
    template: require('./liveUsers.component.html'),
    styles: [require('../SavedStrategiesModal/SavedStrategiesModal.component.css')]
})
export class liveUsersModal extends AppComponentBase {
    constructor(
        injector: Injector,
        public activeModal: NgbActiveModal,
        protected ngbModalService: NgbModal,
        protected globalGridModeService: GlobalGridModeService
    ) {
        super(injector);

        /*********GRID */

        this.gridOptions = <GridOptions>{};
        this.gridOptions.defaultColDef = {
            cellClass: "orders-cell"
            // width:150,
        };

        this.gridOptions.enableFilter = true;
        this.rowSelection = "single";

        this.refreshUserList();

        this.globalGridModeService.UserListUpdate.subscribe(v => {
            this.refreshUserList();
        });

        // this.globalGridModeService.sendModelNewUserSet.subscribe(v => {
        //     console.log("sendModelNewUserSet");

        // //    this.seletedRowParameterSetId = "";
        // });

        /***************GRID* */
    }

    public refreshUserList() {
        // this.workspace
        //     .loadAccounts(this.workspace.userName)
        //     .then(response => {
        //         //console.log(response);

        //         if (response !== null) {
        //             this.workspace.accounts = response;
        //             console.log(response);
        //             this.refreshGridData();
        //         }
        //     })
        //     .catch(error => {
        //         console.error(error);
        //     });
    }

    private _modalSubType: string = "standard";
    public get modalSubType(): string {
        return this._modalSubType;
    }
    public set modalSubType(value: string) {
        this._modalSubType = value;
    }

    /*****************************GRID */

    private _seletedRowParameterSetId: string = "";
    public get seletedRowParameterSetId(): string {
        return this._seletedRowParameterSetId;
    }
    public set seletedRowParameterSetId(value: string) {
        this._seletedRowParameterSetId = value;
    }

    columnDefs = [
        {
            headerName: "Name",
            field: "accountName",
            width: 125,
            filter: "agTextColumnFilter",
            cellStyle: { "text-align": "left" }
        },
        {
            headerName: "Balance",
            field: "balance",
            cellRendererFramework: currencyRenderer,
            width: 125,
            filter: "agTextColumnFilter",
            cellStyle: { "text-align": "left" }
        },
      
    ];

    public gridOptions: GridOptions;
    public rowSelection: any;
    protected gridApi: any;
    protected gridColumnApi: any;

    getRowNodeId(data: any) {
        return data.id;
    }

    public onGridReady(params: GridOptions) {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        if (this.gridApi) this.gridApi.setRowData([]);

        this.refreshGridData();
    }

    refreshGridData() {
        if (this.gridApi) {
            this.gridApi.setRowData([]);

            this.gridApi.updateRowData({ add: this.usersList });

            this.gridApi.clearFocusedCell();
        }
    }

    public onSelectionChanged(e: any) {
        if (this.gridApi !== undefined) {
            let row = this.gridApi.getDisplayedRowAtIndex(e.rowIndex);

            if (row !== undefined) this.seletedRowParameterSetId = row.data.id;
        }
    }

    /*****************END GRID**************** */

    get usersList() {
        return this.workspace.accounts;
    }

    get activeAccountId() {
        return this.workspace.activeAccountId;
    }

   

    bindNewLiveAccount() {
       let s =  `/api/oauth/request?provider=${ this.workspace.currentProvider }&sessionKey=${ this.dataService.getSessionKey() }`;
       window.location.href = `/api/oauth/request?provider=${ this.workspace.currentProvider }&sessionKey=${ this.dataService.getSessionKey() }`
    }

    

    closeWindow() {
        this.activeModal.close();
    }

   
    dissmissAfterEdit = false;

    private _demoName: string = "";
    public get demoName(): string {
        return this._demoName;
    }
    public set demoName(value: string) {
        this._demoName = value;
    }

    private _equityValue: number = 1000;
    public get equityValue(): number {
        return this._equityValue;
    }
    public set equityValue(value: number) {
        this._equityValue = value;
    }


    private _currentRequestId: string = "";

    sendChangeRequest(): void {
        // this.dataService.sendRequest(orderChangeData);
    }
}
